<template>
  <div v-if='client'>
    <wc-page-title :title='title' :subtitle='subtitle'>
      <template v-slot:rightSide>
        <wc-burger-menu>
          <v-list-item @click='confirmHoldToggle' :disabled='client.archived'>
            <v-list-item-icon>
              <v-icon :color='client.on_hold ? "success" : "error"'>{{client.on_hold ? "mdi-thumb-up" : $icons.hold.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ client.on_hold ? "Remove Client Hold" : "Put Client on hold"}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click='confirmArchiveToggle'>
            <v-list-item-icon>
              <v-icon :color='client.archived ? "success" : "error"'>mdi-archive</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ client.archived ? "Un-archive Client" : "Archive Client"}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </wc-burger-menu>
      </template>
    </wc-page-title>
    
    <v-container v-if='client && client.on_hold && !client.archived'>
      <v-alert border='bottom' type='error' :icon='$icons.hold.icon'>This Client has been placed on hold (please see Action Tracker for reason)</v-alert>
    </v-container>
    <v-container v-if='client && client.archived'>
      <v-alert border='bottom' type='error'>This Client has been archived</v-alert>
    </v-container>

    <router-view :client='client' v-if='client' @update='updateClient'></router-view>

    <wc-dialog
      :showDialog='showHoldDialog'
      title='Details Required'
      saveText='Confirm'
      :disableButtons='!isFormValid'
      @cancel='showHoldDialog = false'
      @save='toggleHold'
    >
      <v-form v-model='isFormValid' ref='holdForm'>
        <v-textarea
          outlined
          v-model='message'
          :label='client.on_hold ? "Please state reason for removing hold" : "Please state reason for placing client on hold"'
          hint='This information will be added to an action tracker entry'
          persistent-hint
          :rules='[rules.required]'
        ></v-textarea>
      </v-form>
    </wc-dialog>

    <wc-confirm
      :showDialog='showArchiveDialog'
      @cancel='showArchiveDialog = false'
      @confirm='toggleArchive'
    >
      <v-card-text>
        {{ client.archive ? "Un-archive" : "Archive" }} this Client?
        <br>
        <div class='primary--text font-weight-bold'>{{client.name_display}}</div><br>
        <!-- <div class='font-weight-bold mb-0'>This cannot be easily undone.</div> -->
      </v-card-text>
    </wc-confirm>

  </div>
</template>

<script>
import clientsAPI from '@/modules/clients/api/clients';
import moment from 'moment';
import trackerAPI from '@/api/tracker';
import formRules from '@/mixins/formRules';

export default {
  name: 'client-base',
  mixins: [formRules],
  data: () => ({
    client: null,
    message: "",
    isFormValid: false,
    showHoldDialog: false,
    showArchiveDialog: false,
  }),
  computed: {
    menu () {
      return [
        {
          title: this.$store.state.icons.routes.overview.title,
          icon: this.$store.state.icons.routes.overview.icon,
          route: { name: 'ClientOverview', params: { id: this.$route.params.id } }
        },
        {
          title: this.$store.state.icons.dataBox.invoices.title,
          icon: this.$store.state.icons.dataBox.invoices.icon,
          route: { name: 'ClientInvoices', params: { id: this.$route.params.id } }
        },
        {
          title: this.$store.state.icons.modules.projects.title,
          icon: this.$store.state.icons.modules.projects.icon,
          route: { name: 'ClientProjects', params: { id: this.$route.params.id } }
        },
        {
          title: 'Estimates',
          icon: this.$store.state.icons.modules.estimates.icon,
          route: { name: 'ClientEstimates', params: { id: this.$route.params.id } }
        },
        {
          title: 'Action Tracker',
          icon: this.$store.state.icons.routes.actionTracker.icon,
          route: { name: 'ClientActionTracker', params: { id: this.$route.params.id } }
        }
      ]
    },
    title () {
      if (this.client) {
        return this.client.name_display
      }
      return ''
    },
    subtitle () {
      if (this.client) {
        return this.client.is_company ? 'Company' : 'Individual'
      }
      return ''
    }
  },
  mounted () {
    this.getClient()
  },
  watch: {
    $route() {
      this.getClient()
    }
  },
  methods: {
    async getClient () {
      this.isLoading = true
      this.client = await clientsAPI.getClients(this.$route.params.id)
      this.$store.dispatch('loadSubnavTitle', this.client.name_display)
      this.$store.dispatch('loadSubnav', this.menu)
      this.isLoading = false
    },
    async updateClient (client) {
      this.client = await clientsAPI.updateClient(client)
    },
    confirmArchiveToggle() {
      this.showArchiveDialog = true
    },
    toggleArchive () {
      this.showArchiveDialog = false;
      this.client.archived = !this.client.archived;
      let tmp = this.client.archived ? "Client Archived" : "Client has been Un-archived";
      this.recordAction(tmp);
      this.updateClient(this.client);
    },
    confirmHoldToggle() {
      this.message = '';
      this.showHoldDialog = true;
      this.$nextTick(() => {
        this.$refs.holdForm.resetValidation()
      })
    },
    toggleHold () {
      this.showHoldDialog = false
      this.client.on_hold = !this.client.on_hold
      // need a confirmation dialog here, that user has to indicate hold/removed reason.
      let tmp = this.client.on_hold ? "Client placed on hold" : "Hold removed"
      this.recordAction(tmp + " - " + this.message)
      this.updateClient(this.client)
    },
    async recordAction (action) {

      const tracker = {
          'tracker_data': {
            'description': action,
            'taken_by': this.$store.state.auth.profile.id,
            'action_date': moment().format('YYYY-MM-DD').toString(),
          },
          'client': this.client.id
      }

      await trackerAPI.createClientTracker(tracker);
    }
  },
  components: {
    
  }
}
</script>
